import { useRouter } from 'next/router'

import EmptyLayout from '/components/layouts/EmptyLayout'
import { PAGEURL } from '/constants'
import { EmailForm } from '/components/auth/MagicFlow'
import { withAuthConditions } from '/components/utils'

const MagicLogin = () => {
  const router = useRouter()
  const onComplete = (id) => {
    const url = PAGEURL.MAGIC_LOGIN_PIN + '?id=' + encodeURIComponent(id)
    router.push(url)
  }
  return <EmailForm onComplete={onComplete} />
}

MagicLogin.Layout = EmptyLayout

export const getServerSideProps = withAuthConditions(
  (ctx, siteData) => {
    return {
      props: {
        siteData
      }
    }
  },
  'magic_link',
  'login'
)

export default MagicLogin
